
import { memo } from "react";
import Layout from "@/components/Layout";
import HeroSection from "@/components/index/HeroSection";
import WhatIsMysteryActSection from "@/components/index/WhatIsMysteryActSection";
import FeaturedGamesSection from "@/components/index/FeaturedGamesSection";
import GallerySection from "@/components/index/GallerySection";
import TestimonialsSection from "@/components/index/TestimonialsSection";
import AppDownloadSection from "@/components/index/AppDownloadSection";
import DiscordCommunitySection from "@/components/index/DiscordCommunitySection";
import CTASection from "@/components/index/CTASection";
import ScrollObserver from "@/components/index/ScrollObserver";
import IndexSidebar from "@/components/index/IndexSidebar";
import ResourcePreload from "@/components/index/ResourcePreload";
import SEO from "@/components/SEO";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/context/LanguageContext";

const Index = memo(() => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  
  // Construct ogUrl with language
  const baseUrl = "https://www.anzirtech.com";
  const ogUrl = language === 'en' ? baseUrl : `${baseUrl}/${language}`;

  return (
    <Layout withPadding={false} fullHeight isDarkTheme={true} className="home-page">
      <SEO 
        title={t('nav.home')}
        description={t('app.description')}
        keywords={t('seo.keywords')}
        ogImage="/og-image.webp"
        ogUrl={ogUrl}
        localeAlternates={true}
      />
      <ResourcePreload />
      
      <ScrollObserver>
        <HeroSection />
        <WhatIsMysteryActSection />
        <FeaturedGamesSection />
        <AppDownloadSection />
        <DiscordCommunitySection />
        <GallerySection />
        <TestimonialsSection />
        <CTASection />
      </ScrollObserver>
      
      <IndexSidebar />
    </Layout>
  );
});

Index.displayName = "Index";

export default Index;
